import { render, staticRenderFns } from "./ModalUserPreferences.vue?vue&type=template&id=f20143d2"
import script from "./ModalUserPreferences.vue?vue&type=script&lang=js"
export * from "./ModalUserPreferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ModalUserPreferences.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports